import React, { useContext, useState, useLayoutEffect } from 'react';

import * as S from './styles';
import DynamicPageContext from 'context/DynamicPage';

import DataFormGridOfBanners from 'components/DataFormGridOfBanners';
import AddBannerInGrid from 'components/AddBannerInGrid';
import TabsMaterial from 'components/TabsMaterial';
import { tabsList } from './listTabsflag';
import { DataFormProps } from 'types/InputsGridOfBannersProps';
import { verifyIfFormCanSave } from './functions';
import TypesGridBanners from 'components/TypesGridBanners';

const initialData: DataFormProps = {
	name: '',
	description: '',
	height: '120',
	gap: 2,
	vertical_padding: 0,
	horizontal_padding: 0,
	rounded_size: 0,
	schedule_start: '',
	schedule_end: '',
	countdown: false,
	banners: [],
	typeGridBanners: 0
};

export default function InputsGridOfBanners() {
	const {
		moduleInSavingMode,
		setModuleInSavingMode,
		setCanSaveModuleOnBack,
		setMessageErrorForm,
		moduleOnPhoneToEdit,
		setModuleOnPhoneToEdit
	} = useContext(DynamicPageContext);

	const [tabSelected, setTabSelected] = useState(0);
	const [dataForm, setDataForm] = useState<DataFormProps>(initialData);

	useLayoutEffect(() => {
		//se esta criando um novo componente
		if (moduleInSavingMode !== null) {
			setModuleInSavingMode((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		} else {
			//se esta editando um componente
			setModuleOnPhoneToEdit((obj) => {
				if (obj) {
					return { ...obj, data: dataForm };
				}
				return obj;
			});
		}

		verifyIfFormCanSave(
			dataForm,
			setDataForm,
			setCanSaveModuleOnBack,
			setMessageErrorForm
		);
	}, [dataForm]);

	//se estiver em edição aqui pega os dados do item editado
	useLayoutEffect(() => {
		if (moduleOnPhoneToEdit !== null && moduleInSavingMode === null) {
			setTimeout(() => {
				setDataForm((obj) => ({ ...obj, ...moduleOnPhoneToEdit.data }));
			}, 100);
		}
	}, []);

	return (
		<S.container>
			<TabsMaterial listTabs={tabsList} getPage={setTabSelected} />

			<DataFormGridOfBanners
				isShow={tabSelected === 0}
				dataForm={dataForm}
				setDataForm={setDataForm}
			/>

			<TypesGridBanners
				isShow={tabSelected === 1}
				dataForm={dataForm}
				setDataForm={setDataForm}
			/>

			<AddBannerInGrid
				isShow={tabSelected === 2}
				dataForm={dataForm}
				setDataForm={setDataForm}
			/>
		</S.container>
	);
}
